module.exports = __webpack_public_path__ + "img/平安成电logo(立体效果1)jpg.1f12a50b.jpg";